"use strict";

exports.__esModule = true;
var _NotificationContext = require("./NotificationContext");
Object.keys(_NotificationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationContext[key]) return;
  exports[key] = _NotificationContext[key];
});